let NodeTypes = [
    require('./All-Types/Values/Static-Values/Numbers'),
    require('./All-Types/Values/Static-Values/Date'),
    require('./All-Types/Values/Static-Values/Text'),
    require('./All-Types/Values/Static-Values/Booleans'),
    require('./All-Types/Values/Static-Values/Empty'),

    require('./All-Types/Values/Extractions/Date_Time_Unit'),

    require('./All-Types/Logic/Logic-and-Branching/Condition'),
    require('./All-Types/Logic/Logic-and-Branching/A_And_B'),
    require('./All-Types/Logic/Logic-and-Branching/A_Or_B'),
    require('./All-Types/Logic/Logic-and-Branching/Gate'),
    require('./All-Types/Logic/Logic-and-Branching/Wait_For'),

    require('./All-Types/Logic/Quick-Logic/If_Variable_Changed'),
    require('./All-Types/Logic/Quick-Logic/If_True_False'),
    require('./All-Types/Logic/Quick-Logic/If_Empty'),

    require('./All-Types/Variables/Data-Node-Variables/Extract_Variable'),
    require('./All-Types/Variables/Data-Node-Variables/Extract_Relation'),
    require('./All-Types/Variables/Data-Node-Variables/Extract_Original_Variable'),

    require('./All-Types/Variables/Data-Nodes/Groups'),
    require('./All-Types/Variables/Data-Nodes/User'),
    require('./All-Types/Variables/Data-Nodes/Shop'),

    require('./All-Types/Variables/Dynamic-Nodes/Dynamic_Group'),
    require('./All-Types/Variables/Dynamic-Nodes/Dynamic_Shop'),
    require('./All-Types/Variables/Dynamic-Nodes/Dynamic_Email_List'),

    require('./All-Types/Modifiers/Modify-Numbers-and-Dates/Modify_Number'),
    require('./All-Types/Modifiers/Modify-Numbers-and-Dates/Modify_Date'),
    require('./All-Types/Modifiers/Modify-Numbers-and-Dates/Round_Date'),

    require('./All-Types/Modifiers/Modify-Text/Concatenate_Strings'),

    require('./All-Types/Actions/Do_Nothing'),

    require('./All-Types/Actions/Other-Actions/Send_Notification'),

    require('./All-Types/Actions/Email-Actions/Send_Email'),
    require('./All-Types/Actions/Email-Actions/Signup_Email'),
    require('./All-Types/Actions/Email-Actions/Create_Delete_Email_List'),

    require('./All-Types/Actions/Group-Actions/Add_Remove_From_Group'),
    require('./All-Types/Actions/Group-Actions/Create_Group'),
    require('./All-Types/Actions/Group-Actions/Delete_Group'),
    require('./All-Types/Actions/Group-Actions/Modify_User_Group_Status'),
]

module.exports = NodeTypes;

